import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "plan-card__badge"
}
const _hoisted_2 = { class: "plan-card__content" }
const _hoisted_3 = { class: "plan-card__title" }
const _hoisted_4 = { class: "plan-card__price-text" }
const _hoisted_5 = { class: "wg-no-translate" }
const _hoisted_6 = { class: "plan-card__price" }
const _hoisted_7 = {
  key: 0,
  class: "plan-card__price-subtitle16218"
}
const _hoisted_8 = {
  key: 1,
  class: "plan-card__price-old wg-no-translate"
}

import type { PlanView, BillingView } from '@/models/billing'
import type { PlanPrice } from '@/models/billing.plans'
import { computed } from 'vue'
import TrialBadge from './TrialBadge.vue'
import { trialByPlanV2_18369Treatment } from '@/services/ab/18369_trial_by_plan'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanCard',
  props: {
    plan: {},
    billing: {},
    selected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const oldPrice = computed(() => {
  if (props.plan.id !== 'plan_annual') {
    return
  }

  // Always compare against the monthly plan's price, even once a discount
  // is applied to the annual plan - otherwise the crossed-out price drops
  // to the annual plan's own (undiscounted) price and understates the
  // actual savings shown by savingPercentage.
  return props.billing.monthlyPlan.price
})

const trialLength = computed(() => {
  return props.billing.trialLength(
    props.plan.id === 'plan_annual' ? 'annual' : 'monthly',
  )
})

function getPrice(price: PlanPrice): string {
  if (props.plan.id === 'plan_annual' && props.billing.platform === 'android') {
    // On Android we can't show the annual plan's price per month due to
    // the Play Store rules.
    return price.withPeriod.perYear
  }

  return price.withPeriod.perMonth
}

const savingPercentage = computed(() => {
  if (props.plan.id !== 'plan_annual') {
    return null
  }
  // SwitchToAnnualSavings compares the (possibly discounted) annual price
  // against the monthly price, so it already reflects the full, compounded
  // savings - no need to special-case a discount here.
  return `${props.billing.switchToAnnualSavings.percent}%`
})

const badgeText = computed(() => {
  return `Most Popular • Save ${savingPercentage.value}`
})

const isMonthlyPlanOrAndroid = computed(() => {
  return (
    props.plan.nickname === 'Monthly' || props.billing.platform === 'android'
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["plan-card", { 'plan-card__selected': __props.selected }])
  }, [
    (savingPercentage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(badgeText.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(__props.plan.nickname), 1),
        _createElementVNode("p", _hoisted_4, [
          (isMonthlyPlanOrAndroid.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Billed " + _toDisplayString(__props.plan.labels.frequency), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Billed " + _toDisplayString(__props.plan.labels.frequency) + " at ", 1),
                _createElementVNode("span", _hoisted_5, _toDisplayString(__props.plan.price.perPeriod), 1)
              ], 64))
        ]),
        (!__props.billing.isTrialOver && _unref(trialByPlanV2_18369Treatment)())
          ? (_openBlock(), _createBlock(TrialBadge, {
              key: 0,
              class: "plan-card__trial-badge",
              days: trialLength.value
            }, null, 8, ["days"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["wg-no-translate", { 'plan-card__price-new': __props.plan.id === 'plan_annual' }])
        }, _toDisplayString(getPrice(__props.plan.price)), 3),
        (__props.billing.showExternalPayment16218)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Paying by card "))
          : (__props.plan.id === 'plan_annual' && oldPrice.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(getPrice(oldPrice.value)), 1))
            : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})